import React, { useState, useEffect } from 'react';
import { END_URL, IMG_URL } from "../../config.js";
import "./ResultSlider.css";
import axios from 'axios';
import loadimg from "../../images/loader_wish.gif";

function ResultSlider({dimension}) {

    const bannerImage = dimension?.banner_image
    ? `${IMG_URL}/d0/${dimension.banner_image}`
    : "";

  return (
    <div className='res-slider-main'>
      <div className="container-fluid">
        <div className="row res-row">

          {/* {!bannerImage && (
            <div className="loader-container">
              <img src={loadimg} alt="Loading..." className="loader-gif" />
            </div>
          )} */}
          
          {bannerImage && (
              <img
                src={bannerImage}
                alt="Banner"
                className="img-fluid"
               
              />
          )}

        </div>
      </div>
    </div>
  );
}

export default ResultSlider;
